import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ErroApi } from '../api';
import { Logo } from '../componentes/Logo';
import { Campo, Erro, mascaraCelular } from '../componentes/ui';

export function Entrar() {
  const nav = useNavigate();
  const [celular, setCelular] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  async function continuar() {
    if (enviando) return;
    setErro('');
    setEnviando(true);
    try {
      const r = await api.solicitarCodigo(celular);
      nav('/codigo', {
        state: {
          celular: r.celular,
          celularFormatado: r.celularFormatado,
          validadeMinutos: r.validadeMinutos,
          codigoDeBanca: r.codigoDeBanca,
        },
      });
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui pedir o código agora.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="auth-split">
      <div className="auth-panel">
        <Logo tamanho={36} tamanhoFonte={24} tom="sobreAcento" />
        <div style={{ maxWidth: 460 }}>
          <div className="pill"><span className="dot" /> Documentos fiscais, guardados e distribuídos</div>
          <h1 style={{ fontSize: 44, lineHeight: 1.08, letterSpacing: '-0.035em', marginBottom: 18 }}>
            O mês inteiro já está aqui.
          </h1>
          <p style={{ fontSize: 17, lineHeight: 1.65 }}>
            Cada escritório vê as empresas que atende, cada empresa vê as suas notas.
            Sem pedir arquivo a ninguém.
          </p>
        </div>
        <div className="copyright">© 2026 Conti9 · um produto <strong>Grupo Atendi9</strong></div>
      </div>

      <div className="auth-form-wrap">
        <div className="auth-form fade-up">
          <h2 style={{ fontSize: 29, letterSpacing: '-0.03em', marginBottom: 8 }}>Entrar</h2>
          <p className="muted" style={{ fontSize: 15, marginBottom: 26 }}>
            O código de acesso chega no seu WhatsApp. Não existe senha.
          </p>

          <Erro>{erro}</Erro>

          <Campo rotulo="Celular">
            <div className="phone-input">
              <span className="cc">+55</span>
              <input
                type="tel"
                inputMode="numeric"
                autoComplete="tel-national"
                placeholder="(81) 99999-9999"
                value={celular}
                onChange={(e) => setCelular(mascaraCelular(e.target.value))}
                onKeyDown={(e) => e.key === 'Enter' && continuar()}
              />
            </div>
          </Campo>

          <button className="btn btn-primary" onClick={continuar} disabled={enviando || celular.length < 14}>
            {enviando ? <span className="spinner" /> : 'Receber código no WhatsApp'}
          </button>

          {/* Não existe "criar conta" aqui, e isso é a regra do produto, não
              uma tela que faltou: ninguém entra sem ter sido vinculado a um
              escritório ou a uma empresa por alguém. */}
          <p className="auth-rodape">
            O acesso é dado pelo seu escritório contábil ou pelo Grupo Atendi9.
            Se o código não chegar, fale com quem cuida da sua conta.
          </p>

          <p className="auth-rodape">
            <Link to="/">Voltar para a página inicial</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
